import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check-green_5ba701cefdb19f3336798862e7bf760f",
  "use": "check-green_5ba701cefdb19f3336798862e7bf760f-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"check-green_5ba701cefdb19f3336798862e7bf760f\">\n<circle opacity=\"0.08\" cx=\"24\" cy=\"24\" r=\"24\" fill=\"#35D795\" />\n<path d=\"M21.0002 28.1698L16.8302 23.9998L15.4102 25.4098L21.0002 30.9998L33.0002 18.9998L31.5902 17.5898L21.0002 28.1698Z\" fill=\"#35D795\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol